import BaseService from '@/services/BaseService';

class ProfileService extends BaseService {
    getUserProfile = () => this.get('/get-user-profile');

    editUserProfile = (data) => this.post('/edit-user-profile', data);
}

export default new ProfileService();
